// TradingViewWidget.jsx

import { useDebounce } from "@/helpers/helperFunctions";
import React, {
  memo,
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
export enum TradingViewTimeFrames {
  ONE_MINUTE = "1",
  TWO_MINUTES = "2",
  THREE_MINUTE = "3",
  FIVE_MINUTES = "5",
  FIFTEEN_MINUTES = "15",
  THIRTY_MINUTES = "30",
  ONE_HOUR = "60",
  ONE_AND_HALF_HOUR = "90",
  TWO_HOURS = "120",
  THREE_HOURS = "180",
  FOUR_HOURS = "240",
  ONE_DAY = "D",
  ONE_WEEK = "W",
  ONE_MONTH = "M",
}
let tvScriptLoadingPromise: any;
interface Props {
  symbol?: string;
  interval?: TradingViewTimeFrames;
  darkTheme?: boolean;
  autosize?: boolean;
  overrides?: Record<string, any>;
  containerId?: string;
}
const TradingViewWidget: React.FC<Props> = ({
  symbol = "NASDAQ:AAPL",
  interval = "D",
  darkTheme = true,
  autosize = true,
  containerId,
  overrides = {},
}) => {
  const theme = useMemo(() => (darkTheme ? "dark" : "light"), [darkTheme]);
  const onLoadScriptRef = useRef<any>();
  const updateWidget = useDebounce(
    (options: Props) =>
      tvScriptLoadingPromise?.then(
        () => onLoadScriptRef.current && onLoadScriptRef.current(options)
      ),
    300
  );
  const [widgetLoaded, setWidgetLoaded] = useState<boolean>(false);
  useEffect(() => {
    onLoadScriptRef.current = createWidget;

    if (!tvScriptLoadingPromise) {
      tvScriptLoadingPromise = new Promise((resolve) => {
        const script = document.createElement("script");
        script.id = "tradingview-widget-loading-script";
        script.src = "https://s3.tradingview.com/tv.js";
        script.type = "text/javascript";
        script.onload = resolve;

        document.head.appendChild(script);
      });
    }

    tvScriptLoadingPromise.then(
      () => onLoadScriptRef.current && onLoadScriptRef.current()
    );

    return () => {
      onLoadScriptRef.current = null;
    };

    function createWidget(options: Props = {}) {
      if (
        document.getElementById("tradingview_a8274") &&
        "TradingView" in window
      ) {
        new (window.TradingView as any).widget({
          autosize,
          symbol,
          interval,
          timezone: "Etc/UTC",
          theme,
          style: "1",
          locale: "en",
          enable_publishing: false,
          allow_symbol_change: false,
          hide_top_toolbar: true,
          container_id: containerId || "tradingview_a8274",
          ...options,
          ...overrides,
        });
        setWidgetLoaded(true);
      }
    }
  }, []);
  useEffect(() => {
    if (widgetLoaded)
      updateWidget({
        symbol,
        interval,
        theme,
        autosize,
      });
  }, [symbol, interval, theme, autosize, widgetLoaded]);
  return (
    <div
      className="tradingview-widget-container"
      style={{ height: "100%", width: "100%" }}
    >
      <div
        id={containerId || "tradingview_a8274"}
        style={{ height: "100%", width: "100%" }}
      />
    </div>
  );
};
export default memo(TradingViewWidget);
